module.exports = {
    hide:'隐藏当前列',
    showall:'展开所有列',
    showatone:'至少保留一列',
    runReport: '运行报告',
    reset: '重置',
    today: '今天',
    yesterday: '昨天',
    last7Days: '过去7天',
    last30Days: '过去30天',
    last60Days: '过去60天',
    last90Days: '过去90天',
    thisMonth: '本月',
    status: '状态',
    Comfirm:'确认',
    addNew: '新增',
    add: '添加',
    childs:'相关视频连接详情',
    isEmpty:'必须填写',
    Aff_cost:'Aff花费',
    history:'历史案例',
    caf:'清除全部过滤条件',
    advname:'广告主名称',
    adds:'新增',
    createADV:'创建新的ADV',
    deletekol:'点击确定会删除本条网红记录，是否确定继续删除？',
    coop:'合作类型',
    edit: '编辑',
    fileUP:'您上传的文件格式系统暂不支持,请上传PDF格式文件。',
    official:'自动',
    trackingSystem:'归因系统',
    advGroup:'广告主组',
    fileLarge:'上传文件超过500M',
    sorry:'暂时没有获取到对应的网红平台连接,请更新数据后重新尝试！',
    refresh:'更新数据',
    noofficial:'手动',
    all:'全部',
    shengcheng:'确认生成流程？',
    jieshu:'确认拒绝该网红？',
    repeathave:'您选择的维度重复了，请重新设置',
    cpa:'CPA',
    videolink:'视频链接',
    nolimits:'该流程已经关闭,无法操作该流程',
    cpi:'CPI',
    nocampaign:'产品',
    event_method:'事件方法',
    formatimg:'您上传的图片文件大小不符合要求，请上传20M以内的文件',
    pptpdf:'您上传的文件格式不符合要求，请上传Ppt、Pdf、Word或Excel格式的文件',
    pdf:'您上传的文件格式不符合要求，请上传PDF格式的文件',
    notime:'预约金额不为空，预约时间必须填写',
    nomediasource:'媒体资源,',
    nocountry:'国家,',
    haventchoose:'的产品权限没有配置',
    noeventName:'事件名称,',
    noprice:'价格,',
    costseeting:'成本价为必填项，请完善表中每一个媒体资源的价格',
    timewrong:'预约价格的开始时间须大于当前时间',
    delete: '删除',
    image:'图片',
    clcick:'点击跳转至结案报告页面',
    tokoltrack:'您有新流程更新,请您及时查看',
    video:'视频',
    launch: '发布',
    Notification:'通知',
    checkfail:'广告主已存在',
    noexist:'广告主不在列表',
    Input:'请输入',
    togray:'由于计算规则限制，该字段置灰',
    Selects:'请选择',
    unLaunch: '取消发布',
    siteId:'广告系列',
    launched: '已发布',
    UploadSuccess:'上传成功',
    completeIfo:'请先完善信息',
    launchSuccess:'发布成功',
    nodata:'没有数据',
    leastOne:"至少选择一条数据",
    formattips:'您选择的文件格式不符',
    clearFilters: '清空筛选',
    total: '汇总',
    items: '项',
    changePassword: '更改密码',
    logout: '登出',
    deleteSuccess: '删除成功',
    addSuccess: '添加成功',
    editSuccess: '编辑成功',
    whatsnew: '新闻',
    HelpCenter: '帮助中心',
    HelpCenterView: '帮助中心',
    notifications: '通知',
    top5MediaSource: 'Top5媒体资源分布',
    top5App: 'Top5应用产品分布',
    country: '国家',
    advertiser: '广告主',
    cost: '花费',
    search: '搜索',
    dateRange:'时间区间',
    platform: '平台',
    language: '语言',
    setting: '设置',
    changePassword: '修改密码',
    resetPWD:'重置密码',
    changePasswordTips1: '如果您有任何问题，',
    changePasswordTips2: '请随时联系您的账户管理员。',
    originalPassword: '原密码',
    newPassword: '新密码',
    enterNewPasswordAgain: '确认新密码',
    save: '保存',
    coludBeStronger: '可能会更强',
    strongPassword: '高强度密码',
    pleaseEnterTheOriginPassword: '请输入原密码',
    pleaseEnterThePassword: '请输入新密码',
    enterNewPasswordAgainTips: '请再次输入新密码',
    enterSamePassword: '请输入相同的密码',
    settingYourPassword: '设置密码',
    settingYourPasswordTips1: '欢迎你来了！',
    settingYourPasswordTips2: '为了您的账号安全，请设置密码。',
    later: '后',
    PasswordSettingSuccess1: '密码设置',
    PasswordSettingSuccess2: '成功！',
    logbackWithNewPasswordTips1: '您的帐户将自动注销，',
    logbackWithNewPasswordTips2: '请用新密码重新登录',
    ok: '确认',
    logback: '重新登录',
    upload: '上传',
    confirm: '确认',
    cancel: '取消',
    confirmTips1: '删除确认',
    zhixing:'执行确认',
    rejconfirm:'拒绝确认',
    okconfirm:'确认同意',
    confirmTips2: '请确认是否删除已选项？',
    launchTips1: '发布确认',
    launchTips2: '一旦发布, 客户将阅读这些更新',
    launchTips3: '报告.',
    replace: '替换',
    allSelect: '全选',
    unread: '未读',
    allUpdate: '所有更新',
    inputSearchText: '输入搜索文本',
    date: '按天聚合',
    dats:'日期',
    exportReport: '导出报告',
    operate: '操作',
    addbefore:'每个业务只能创建8个子账号，如有其他问题请联系您的YM对接人',
    addbeforenotice:'您没有权限创建更多帐号了，如有其他问题请联系YM对接人',
    pleaseHoldon: '努力加载中，请稍等...',
    move:'移动',
    upOne:'上移一层',
    downOne:'下移一层',
    TopOne:'置于顶层',
    Today:'今天',
    Yesterday:'昨天',
    Last7Days:'过去七天',
    LastMonth:'上个月',
    ThisMonth:'当前月',
    pkg:'应用包',
    CustomRange:'自定义',
    deleteSure:'确定删除吗？',
    Campaign:'产品',
    Cost:'花费',
    ViewCounts:'播放量',
    noAuthority:'没有权限操作!',
    pia:'请输入接口',
    pim:'请输入方法',
    pimn:'请输入模块名',
    picn:'请输入类名',
    psr:'请选择角色',
    className:'类名',
    moduleName:'模块名',
    method:'方法',
    action:'接口',
    searchaction:'搜索接口',
    no:'排序',
    Apply:'确定',
    authority:'权限ID',
    changeSuccess:'修改成功',
    accountOne:'账户号已经被选择，请重新进行选择!',
    modulechosens:'Head Of Account的职位中已经包含此模块，请重新选择',
    emptymodule:'模块不能为空，至少要选择一个',
    allread:'全部标记为已读',
    allreadtitle:'全部标记为已读',
    readsure:'通知栏中全部通知将更新至已读状态，确认继续？',
    Yes:'确定',
    No:'取消',
    haveit:'此piknamge下的mediasource已经存在,请修改后重新保存',
    limitDDateRangeTip: '这里最多支持3个月的查询',
    tooltipYes: '是',
    tooltipNo: '否',
    uf:'更新失败',
    deletefail:'删除失败',
    noconversionType:'转化类型,',
    retargeting: '再营销',
    event: '事件',
    settingStatusInfo: '暂停后，数据将停止更新，是否确定暂停？',
    emailFormatwrong:'邮箱格式不正确',
    statschange:'确定修改状态吗？',
    pwsworng:'请填写正确的用户名/密码'
}



// WEBPACK FOOTER //
// ./src/i18n/modules/public/zh-cn.js